import Config from "@_configs/api.config";
import { createBrowserHistory } from "history";

export const customerService = {
  customer,
};

export const history = createBrowserHistory();

export function clearToken() {
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("case_id");
}

export function handleResponse(response) {
  // Handle case where response is null/undefined
  if (!response) {
    return Promise.reject({
      error_message:
        "We can’t connect right now. Please try again in a moment or refresh the page.",
      error_code: 0,
    });
  }

  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
        clearToken();
        history.push("/login");
      }
      if (
        response.status === 400 ||
        response.status === 404 ||
        response.status === 500
      ) {
        const error = {
          error_message: data.error_message,
          error_code: data.error_code,
        };
        return Promise.reject(error);
      } else {
        const error = (data && data.error_code) || response.status;
        return Promise.reject(error);
      }
    }
    return data;
  });
}

function customer(host, language, caseId, userId, user_device_info) {
  let uri = `${Config.API_ROOT}customer/config?host=${host}&translation=${language}`;
  if (caseId) uri += `&case_id=${caseId}`;
  if (userId) uri += `&user_id=${userId}`;

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user_device_info }),
  };

  return fetch(uri, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      // Handle network errors - if already formatted, pass through; otherwise format
      if (error && typeof error === "object" && error.error_code !== undefined) {
        return Promise.reject(error);
      }

      return Promise.reject({
        error_message:
          "We can’t connect right now. Please try again in a moment or refresh the page.",
        error_code: 0,
      });
    });
}
